import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import {
  sendTemplateFile,
  getDefaultLanguage,
  updateDefaultLanguage
} from 'api/custom-template';
import FileUpload from '../components/coverage/FileUpload';
import TemplateConfirmationModal from '../components/custom-template/TemplateConfirmationModal';
import DefaultLanguageSelector from '../components/custom-template/DefaultLanguageSelector';
import SUPPORTED_LANGUAGES from '../enums/SupportedLanguages.enum';

import {
  Tabs,
  Tab,
  Box,
  Typography
} from '@mui/material';
import TabPanel from 'components/atoms/TabPanel';
import { COLORS } from 'colors';



const CustomTemplate = () => {
  const [defaultLanguage, setDefaultLanguage] = useState('en');
  const [isLoadingLanguage, setIsLoadingLanguage] = useState(true);
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isMailSent, setIsMailSent] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const fetchDefaultLanguageAsync = async () => {
    try {
      const response = await getDefaultLanguage();
      setDefaultLanguage(response.data.language_code);
    } catch (error) {
      toast.error('Failed to load language settings');
    } finally {
      setIsLoadingLanguage(false);
    }
  };

  useEffect(() => {
    fetchDefaultLanguageAsync();
  }, []);

  const handleLanguageChange = async (newCode) => {
    const loadingToast = toast.loading('Updating language settings...');
    try {
      await updateDefaultLanguage(newCode);
      toast.dismiss(loadingToast);
      setDefaultLanguage(newCode);
      toast.success('Language settings updated successfully!');
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error('An error occurred while updating language settings');
    }
  };

  const handleConfirmationChoice = async (choice) => {
    if (choice !== 'yes' || !selectedFile) {
      setShowConfirmationModal(false);
      return;
    }

    setShowConfirmationModal(false);
    setUploadInProgress(true);
    const loadingToast = toast.loading('Sending your custom template...');

    try {
      const response = await sendTemplateFile({
        file: selectedFile,
        fileType: selectedFile.type
      });

      toast.dismiss(loadingToast);

      if (response.status === 200) {
        setIsMailSent(true);
        toast.success('Custom template sent successfully!');
      } else {
        if (response.message === 'Unauthorized user') {
          setTimeout(() => window.location.reload(), 2000);
        }
        toast.error(response.message || 'Something went wrong');
      }
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error('An error occurred while sending the template');
    }
    setUploadInProgress(false);
  };

  const handleTabChange = (_e, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div className="text-white">
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        setIsLoadingLanguage
        textColor="inherit"
        indicatorColor="primary"
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: COLORS.PRIMARY // your Tailwind `primary`
          }
        }}>
        {/* <Tab label="Custom Template" id="custom-tab-0" className="!font-semibold" /> */}
        <Tab label="Default Language" id="custom-tab-1" className="!font-semibold" />
      </Tabs>

      {/* <TabPanel value={tabIndex} index={0}>
        <FileUpload
          title="Upload Custom Coverage Template"
          subtitle="Upload your own coverage template in .doc or .docx format and we will update your reports to use this template in 1 day."
          isCustomTemplate
          setUploadedFile={setSelectedFile}
          setConfirmationModal={setShowConfirmationModal}
          isMailSent={isMailSent}
          uploadInProgress={uploadInProgress}
        />
      </TabPanel> */}

      <TabPanel value={tabIndex} index={0}>
        <DefaultLanguageSelector
          languages={SUPPORTED_LANGUAGES}
          selectedLanguage={defaultLanguage}
          onChange={handleLanguageChange}
          disabled={isLoadingLanguage}
          label="Select Your Output Language for Coverage"
        />
      </TabPanel>

      <TemplateConfirmationModal
        confirmationModal={showConfirmationModal}
        setConfirmationModal={setShowConfirmationModal}
        suretyClickHandler={handleConfirmationChoice}
      />
    </div>
  );
};

export default CustomTemplate;
